import { repeatInt } from './math';
import $ from 'jquery';
import inView from 'in-view';

const SELECTOR = '.rotating-words';
const ANIMATOR = '.aos-section';

const DISPLAY_TIME = 2; //seconds
const NEXT_WORD_DELAY = 0.25; //seconds
const WPM = 200;// Typing speed
const DELETE_TIME = 0.3; //Ratio of time to delete a character to typing one

const MILLISECONDS_PER_CHARACTER = (1000 * 60) / (WPM * 5);

const blockStates = {
	typing: {
		enter: ($el) => {
			const words = $el.data('words');

			if (!words) {
				setElementState($el, null);
				return;
			}

			const wordIndex = $el.data('wordIndex');
			$el.data('currentWord', words[wordIndex]);
			elementTypeCharacter($el);
		},
		exit: ($el) => { },
	},

	waitingToDelete: {
		enter: ($el) => {
			setTimeout(
				() => setElementState($el, blockStates.deleting),
				DISPLAY_TIME * 1000
			);
		},
		exit: ($el) => { },
	},

	deleting: {
		enter: ($el) => {
			elementDeleteCharacter($el);
		},
		exit: ($el) => {
			const currentWordIndex = $el.data('wordIndex');
			const words = $el.data('words');

			if (!words) {
				setElementState($el, null);
				return;
			}

			const i = repeatInt(currentWordIndex + 1, words.length);
			$el.data('wordIndex', i);
		},
	},

	waitingToType: {
		enter: ($el) => {
			setTimeout(() => {
				setElementState($el, blockStates.typing);
			}, NEXT_WORD_DELAY * 1000);
		},
		exit: ($el) => { },
	},
};

function onDocumentReady() {
	inView(ANIMATOR).on('enter', onLayoutEnter);
}

function onLayoutEnter(el) {
	const selector = $(SELECTOR);
	$(el).find(selector).each(function() {
		const e = $(this);
		if(e.hasClass('initialized')) {
			return;
		}
		e.each(initializeElement);
	});
}

function initializeElement(i, el) {
	const $el = $(el);
	$el.addClass('initialized');
	$el.data('wordIndex', 0);

	setElementState($el, blockStates.waitingToDelete);
}

function setElementState($el, state) {
	const currentState = $el.data('currentState');
	if (currentState) {
		currentState.exit($el);
	}

	if (state) {
		state.enter($el);
	}
	$el.data('currentState', state);
}

function elementTypeCharacter($el) {
	const currentText = $el.text();
	const currentWord = $el.data('currentWord');

	if (!currentWord) {
		setElementState($el, null);
		return;
	}

	$el.text(currentWord.substr(0, currentText.length + 1));

	if (currentText === currentWord) {
		setElementState($el, blockStates.waitingToDelete);
	} else {
		setTimeout(() => elementTypeCharacter($el), MILLISECONDS_PER_CHARACTER);
	}
}

function elementDeleteCharacter($el) {
	const text = $el.text();

	$el.text(text.substr(0, Math.max(0, text.length - 1)));

	if (!text) {
		setElementState($el, blockStates.waitingToType);
	} else {
		setTimeout(
			() => elementDeleteCharacter($el),
			DELETE_TIME * MILLISECONDS_PER_CHARACTER
		);
	}

}

document.addEventListener('DOMContentLoaded', onDocumentReady);
